<template>
  <main :class="style.main">
    <img
      src="$images/Brand.LightBeam.Right.png"
      alt=""
      :class="style.background"
    />
    <div :class="style.buttons">
      <SecondaryButton text="Квизы" @click="goToQuiz" />
      <SecondaryButton text="Онлайн запись" @click="goToSetting" />
    </div>
  </main>
</template>

<script lang="ts">
import style from "./startHomePage.module.scss";
import {defineComponent} from "vue";
import SecondaryButton from "@/elements/UI/button/ButtonStyle/Default/secondary/SecondaryButton.vue";
import {user} from "@/page/setting/account/userTypes";

export default defineComponent({
  name: "startHomePage",
  components: {SecondaryButton},
  data() {
    return {
      style
    };
  },
  methods: {
    goToQuiz(): void {
      this.$router.push("/quiz");
    },

    goToSetting(): void {
      this.$router.push("/setting");
    }
  },
  computed: {
    userData(): user {
      return this.$userStore.getUser;
    }
  }
});
</script>
